import * as React from 'react';

import Tooltip from 'components/Tooltip';
import InstagramDataEnabledBadge from 'components/instagram-data-enabled/badge/InstagramDataEnabledBadge';

import TileStandardContext from 'components/tiles/standard/context/TileStandardContext';

import './tile-standard-content-details-channel.scss';

import type { Channel } from 'types';

type Props = {
  activeChannel: Channel,
  channelString: string
};

const TileStandardContentDetailsChannel = (
  {
    activeChannel,
    channelString
  }: Props
): JSX.Element => {
  const context = React.useContext(TileStandardContext);
  const label = activeChannel.username
    ? `@${activeChannel.username}`
    : activeChannel.url;

  return (
    <div className="tile-standard-content-details-channel">
      <Tooltip
        message={channelString}
        width="auto-compact"
        classNameWrapper="tile-standard-content-details-channel__tooltip text-overflow-ellipsis"
      >
        <a
          href={activeChannel.url}
          title={label}
          target="_blank"
          rel="noopener noreferrer"
          className="tile-standard-content-details-channel__link"
        >
          {label}
        </a>
      </Tooltip>
      {
        activeChannel.type === 'instagram' && Boolean(context?.creator.hasActiveFbConnection) ? (
          <div className="tile-standard-content-details-channel__enabled-profile">
            <InstagramDataEnabledBadge
              hasActiveFbConnection={Boolean(context?.creator.hasActiveFbConnection)}
            />
          </div>
        ) : null
      }
    </div>
  );
};

export default TileStandardContentDetailsChannel;
